module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer006",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-center"
  }, [_vm._v("This book is dedicated to Casey...")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("I was blessed to help raise you and I’m absolutely delighted with the wonderful young woman you’ve become. You are a part of us...and always will be. You can’t get rid of me easily! Love you, kid.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5ae74a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dedication.vue
// module id = 75
// module chunks = 0